import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/public/media/images/icon-country-flag-sg.png");
;
import(/* webpackMode: "eager" */ "/app/public/media/images/image-comprehensivecurriculum.png");
;
import(/* webpackMode: "eager" */ "/app/src/app/blocks/ContentBlockWithImageLeft.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/blocks/FaqsAccordionBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/blocks/ReviewCarouselBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/blocks/SimpleContentBlockWithHeaderOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Component-GroupSwimming.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Component-LocationGallery.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Component-PlansAndPrices.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Component-SellingPoints.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Component-SwimmingProgramme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Component-SwimmingProgrammeBanner.tsx");
